import { render } from "./home-three-blog.vue?vue&type=template&id=140c1c83"
import script from "./home-three-blog.vue?vue&type=script&lang=js"
export * from "./home-three-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__